/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A Vikimap service module to use for a Vikimap driven application. Supports Accedo One, JSON and Middleware services. (@accedo/vdkweb-vikimap) 4.0.6
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getService = exports.getMiddlewareService = exports.getJsonService = exports.getAppGridService = exports.getAccedoOneService = exports.SERVICE_TYPE = void 0;

var _deprecationWarning = _interopRequireDefault(require("./utils/deprecationWarning"));

var _vikimapService = _interopRequireDefault(require("./vikimapService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SERVICE_TYPE = {
  APPGRID: 'accedoOne',
  // Keeping this for backwards compatibility.
  JSON: 'json',
  MIDDLEWARE: 'middleware',
  ACCEDO_ONE: 'accedoOne'
};
/**
 * Creates a Vikimap service with a configured entry provider of
 * the given type.
 *
 * @param {string} serviceType The service type to create
 * @param {any} options The options for configuring the entry provider for the given service type
 * @returns {object} The Vikimap service
 */

exports.SERVICE_TYPE = SERVICE_TYPE;

var getService = function getService(serviceType, options) {
  // eslint-disable-next-line import/no-dynamic-require
  var EntryProvider = require("./entryProviders/".concat(serviceType))["default"];

  return new _vikimapService["default"](new EntryProvider(options));
};
/**
 * Retrieves an Accedo One service for fetching Vikimap content.
 * @param  {object} accedoOneClient   A prepared Accedo One client to use for Accedo One requests
 * @return {object}                   The Accedo One Vikimap service.
 */


exports.getService = getService;

var getAccedoOneService = function getAccedoOneService(accedoOneClient) {
  return getService(SERVICE_TYPE.APPGRID, accedoOneClient);
};
/**
 * Retrieves an AppGrid service for fetching Vikimap content.
 *
 * @deprecated Use getAccedoOneService() instead
 *
 * @param  {object} appGridClient   A prepared AppGrid client to use for AppGrid requests
 * @return {object}                  The AppGrid Vikimap service.
 */


exports.getAccedoOneService = getAccedoOneService;

var getAppGridService = function getAppGridService(appGridClient) {
  (0, _deprecationWarning["default"])('getAppGridService has been deprecated, please use getAccedoOneService instead.');
  return getService(SERVICE_TYPE.APPGRID, appGridClient);
};
/**
 * Retrieves a JSON service for fetching Vikimap content.
 * @param  {object} json The JSON object with all entry contents
 * @return {object}      The JSON Vikimap service.
 */


exports.getAppGridService = getAppGridService;

var getJsonService = function getJsonService(json) {
  return getService(SERVICE_TYPE.JSON, json);
};
/**
 * Retrieves a middleware service for fetching Vikimap content.
 * @param  {object} rootPath  The root URL path for the middleware
 * @return {object}           The middleware Vikimap service.
 */


exports.getJsonService = getJsonService;

var getMiddlewareService = function getMiddlewareService(rootPath) {
  return getService(SERVICE_TYPE.MIDDLEWARE, rootPath);
};

exports.getMiddlewareService = getMiddlewareService;